import { useNavigate } from "react-router-dom";
import GlobalForm from "../../components/globalForm/GlobalForm";
import { updateData } from "../../hooks/update";
import { apiPath } from "../../utility/Constant";

const PackageCreate = () => {
  const { packageApi } = apiPath;
  const navigate = useNavigate();

  const data = [
    {
      elementType: "input",
      label: "Package Name",
      type: "Text",
      name: "packageName",
      required: true,
    },
    {
      elementType: "input",
      label: "Package Price",
      type: "Text",
      name: "price",
      required: false,
    },
    {
      elementType: "textField",
      label: "Package Details",
      type: "Text",
      name: "details",
      required: true,
    },
    {
      elementType: "input",
      label: "Package Recommendation",
      type: "Text",
      name: "reco",
      required: true,
    },
    {
      elementType: "select",
      label: "Featured",
      type: "Text",
      name: "featured",
      required: false,
      options: ["false", "true"],
    },
  ];

  const update = (data) => {
    updateData(packageApi, data, null, null, null, true);
    navigate("/packageList");
  };
  return (
    <div>
      <GlobalForm data={data} update={update} />
    </div>
  );
};

export default PackageCreate;
